<template>
  <SkeletonLoader>
    <div class="tasks-skeleton">
      <div class="tasks-skeleton__input">
        <div class="sk-rect" style="height: 44px; width: 100%; border-radius: 8px;"></div>
      </div>

      <div class="tasks-skeleton__filters">
        <div class="sk-rect" style="height: 32px; width: 120px; border-radius: 16px;"></div>
        <div class="sk-rect" style="height: 32px; width: 100px; border-radius: 16px;"></div>
        <div class="sk-rect" style="height: 32px; width: 140px; border-radius: 16px;"></div>
      </div>

      <div class="tasks-skeleton__header">
        <div class="sk-rect" style="height: 14px; width: 40%;"></div>
        <div class="sk-rect" style="height: 14px; width: 80px;"></div>
        <div class="sk-rect" style="height: 14px; width: 80px;"></div>
        <div class="sk-rect" style="height: 14px; width: 100px;"></div>
      </div>

      <div v-for="i in 8" :key="'task-' + i" class="tasks-skeleton__row">
        <div class="sk-rect" style="width: 18px; height: 18px; border-radius: 4px; flex-shrink: 0;"></div>
        <div class="sk-col" style="flex: 3;">
          <div class="sk-line" :style="{ width: rowWidths[i] }"></div>
        </div>
        <div class="sk-col" style="flex: 1;">
          <div class="sk-line sk-line--sm" :style="{ width: colWidths[i] }"></div>
        </div>
        <div class="sk-col" style="flex: 1;">
          <div class="sk-rect" style="height: 22px; width: 60px; border-radius: 12px;"></div>
        </div>
        <div class="sk-col" style="flex: 1;">
          <div class="sk-line sk-line--sm" :style="{ width: dateWidths[i] }"></div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue';

export default {
  name: 'TasksSkeleton',
  components: { SkeletonLoader },
  data() {
    return {
      rowWidths: { 1: '70%', 2: '55%', 3: '80%', 4: '45%', 5: '65%', 6: '75%', 7: '50%', 8: '60%' },
      colWidths: { 1: '60%', 2: '45%', 3: '70%', 4: '55%', 5: '40%', 6: '65%', 7: '50%', 8: '60%' },
      dateWidths: { 1: '70%', 2: '55%', 3: '60%', 4: '75%', 5: '50%', 6: '65%', 7: '80%', 8: '55%' },
    };
  }
}
</script>

<style lang="scss" scoped>
.tasks-skeleton {
  padding: 20px;
}

.tasks-skeleton__input {
  margin-bottom: 16px;
}

.tasks-skeleton__filters {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
}

.tasks-skeleton__header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 12px;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 4px;
}

.tasks-skeleton__row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 12px;
  border-bottom: 1px solid #f1f5f9;
}

@media (max-width: 768px) {
  .tasks-skeleton {
    padding: 12px;
  }

  .tasks-skeleton__header {
    display: none;
  }

  .tasks-skeleton__row {
    .sk-col:nth-child(n+3) {
      display: none;
    }
  }

  .tasks-skeleton__filters {
    flex-wrap: wrap;
  }
}
</style>
